<div class="page-container">
  
  <!-- LOADING STATE -->
  @if (!hasData() && !error()) {
    <div class="loading-screen">
      <div class="spinner"></div>
      <p>Loading Session...</p>
    </div>
  }

  <!-- ERROR STATE -->
  <!-- ERROR STATE -->
@if (error()) {
  <div class="error-screen">
    <!-- Optional Title -->
    <h2>{{ 'errorMessages.title' | translate }}</h2> 
    
    <!-- THE ERROR MESSAGE -->
    <!-- Maps 'recording-not-found' to 'error.recording-not-found' -->
    <p>{{ 'errorMessages.' + error() | translate }}</p>
    
    @if (showLogin()) {
      <button class="action-btn" (click)="redirectToLogin()">
        {{ 'user.login-button' | translate }}
      </button>
    }
  </div>
}

  <!-- CONTENT STATE -->
  @if (selectedAngle(); as currentAngle) {
    <header>
      <div class="header-left">
        
        <!-- BACK LINK -->
        @if (teamId()) {
          <a class="back-btn" 
             [routerLink]="['/teamRecordings', teamId()]" 
             [queryParams]="backLinkParams"
             title="Back to Recordings">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
              <path fill-rule="evenodd" d="M11.03 3.97a.75.75 0 010 1.06l-6.22 6.22H21a.75.75 0 010 1.5H4.81l6.22 6.22a.75.75 0 11-1.06 1.06l-7.5-7.5a.75.75 0 010-1.06l7.5-7.5a.75.75 0 011.06 0z" clip-rule="evenodd" />
            </svg>
          </a>
        }
        
        <h1>Recording Session</h1>
      </div>

      <div class="header-center">
        @if (angles().length > 1) {
          <div class="angle-switcher">
            @for (angle of angles(); track angle.videoUrl) {
              <button 
                class="angle-btn" 
                [class.active]="currentAngle === angle"
                (click)="selectAngle(angle)"
                [title]="angle.displayName">
                
                <div class="thumb-wrapper">
                  <video 
                    [src]="angle.videoUrl + '#t=1'" 
                    preload="metadata" 
                    muted 
                    playsinline>
                  </video>
                </div>
                
                <span class="angle-label">{{ angle.displayName }}</span>
              </button>
            }
          </div>
        }
      </div>

      <div class="meta">
        Start: {{ currentAngle.recordingStartTime | date:'yyyy-MM-dd HH:mm:ss' }}
      </div>
    </header>

    <div class="video-stage">
      @if (currentAngle.panoType === 'equirectangular') {
        <app-sphere-video-player
          [videoUrl]="currentAngle.videoUrl"
          [panoData]="currentAngle.panoData"
          [recordingStartTime]="currentAngle.recordingStartTime"
          [startTimeSec]="lastPlaybackTime()"
          [fps]="currentAngle.panoData?.fps ?? null"
          (timeUpdate)="lastPlaybackTime.set($event)">
        </app-sphere-video-player>
      } @else {
        <app-flat-video-player
          [videoUrl]="currentAngle.videoUrl"
          [recordingStartTime]="currentAngle.recordingStartTime"
          [startTimeSec]="lastPlaybackTime()"
          [fps]="currentAngle.panoData?.fps ?? null"
          (timeUpdate)="lastPlaybackTime.set($event)">
        </app-flat-video-player>
      }
    </div>
  }

</div>